import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { ActiveCallKey } from 'flow/types/EntityKeys';
import { twMerge } from 'tailwind-merge';

import { selectOwnUserHasCapabilityTickets } from 'flow/selectors/TicketsSelectors';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import { useModal } from 'flow/contexts/ModalProvider';
import {
    selectOwnActiveLineCallState,
    selectOwnActiveLineLocutusSessionId,
    selectOwnActiveLineQueueKey,
} from 'flow/selectors/call-selectors';

interface Props {
    className?: string;
    activeCallKey?: ActiveCallKey;
}

const WidgetCreateTicket = ({ className, activeCallKey }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const hasCapabilityTickets = useAppSelector(
        selectOwnUserHasCapabilityTickets,
    );
    const locutusSessionId = useAppSelector((state) =>
        selectOwnActiveLineLocutusSessionId(state, activeCallKey),
    );
    const queueKey = useAppSelector((state) =>
        selectOwnActiveLineQueueKey(state, activeCallKey),
    );
    const callState = useAppSelector((state) =>
        selectOwnActiveLineCallState(state, activeCallKey),
    );

    if (!hasCapabilityTickets || !queueKey || callState === 'ringing')
        return null;
    //if a ticketKey does not exist, and if either: user does not have capability tickets, or call is not a queue call, or call is in ringing state, we return null

    return (
        <div className={twMerge('h-9 min-w-0', className)}>
            <button
                className="size-full cursor-pointer rounded-sm bg-gray-700 text-xs text-white"
                onClick={() =>
                    openModal('ticketCreateViaQueueCall', {
                        callRecordKey: `call-${locutusSessionId}`,
                        queueKey,
                        context: 'call_canvas',
                        activeCallKey,
                    })
                }
            >
                <div className="flex size-full items-center justify-between gap-x-4 p-3">
                    <div className="truncate font-light">
                        {i18next.t('tickets.ticket.create_ticket')}
                    </div>
                    <IconButton
                        tooltipLabel={i18next.t('tickets.ticket.create_ticket')}
                        className="size-6 rounded-sm bg-gray-600 p-2"
                    >
                        <Icon iconKey="add" />
                    </IconButton>
                </div>
            </button>
        </div>
    );
};

export default WidgetCreateTicket;
